import api from "./init";
import { headers } from "./apiHelper";

export const getTopics = (resolveHandler, offset = 0, limit = 100) => {
  api
    .get("/topics", {
      headers,
      params: {
        offset: `${offset}`,
        limit: `${limit}`,
      },
    })
    .then((res) => {
      resolveHandler(res.data);
    });
};

export const getTopic = (id, resolveHandler) => {
  api
    .post(
      "/exams",
      {
        type: "TOPIC",
        entityId: id,
      },
      {
        headers,
      }
    )
    .then((res) => {
      resolveHandler(res.data);
    });
};

export const submitTopic = (examID, examAnswers, examTime, resolveHandler) => {
  api
    .post(
      `/exams/${examID}`,
      {
        answers: examAnswers,
        time: examTime,
      },
      {
        headers,
      }
    )
    .then((res) => {
      resolveHandler(res.data);
    });
};
